module.exports = __webpack_public_path__ + "img/face_swapper.609607ff.png";